import { render } from "./EeiaSocial.vue?vue&type=template&id=2aaf8be9&scoped=true"
import script from "./EeiaSocial.vue?vue&type=script&lang=js"
export * from "./EeiaSocial.vue?vue&type=script&lang=js"

import "./EeiaSocial.vue?vue&type=style&index=0&id=2aaf8be9&scoped=true&lang=css"

import exportComponent from "/var/www/html/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaf8be9"]])

export default __exports__